module.exports = __webpack_public_path__ + "static/media/cardbg1.fe44c49b.jpg";